import React, { useEffect, useState } from "react";

const MAGIC_MAP_URL = "/labyrinthe/carte.html?embed=selena-matrix";

export default function MagicMapPage() {
  const [selectedDomain, setSelectedDomain] = useState("");

  useEffect(() => {
    const receiveMessage = (event) => {
      if (event.origin !== window.location.origin || !event.data) return;

      if (event.data.type === "LABYRINTHE_DOMAIN_SELECTED") {
        const domain = event.data.domain || {};

        setSelectedDomain(domain.label || domain.id || "");

        sessionStorage.setItem(
          "dncm_selected_domain",
          JSON.stringify({
            ...domain,
            selected_at: new Date().toISOString()
          })
        );
      }
    };

    window.addEventListener("message", receiveMessage);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <div>
          <div style={styles.brand}>SELENA MATRIX</div>
          <div style={styles.subtitle}>CARTE MAGIQUE DU LABYRINTHE</div>
        </div>

        {selectedDomain && (
          <div style={styles.selection}>ESPACE ACTIF : {selectedDomain}</div>
        )}

        <button
          type="button"
          style={styles.backButton}
          onClick={() => window.location.href = "/"}
        >
          ← RETOUR À SELENA
        </button>
      </header>

      <iframe
        title="Carte Magique du Labyrinthe"
        src={MAGIC_MAP_URL}
        style={styles.iframe}
      />
    </div>
  );
}

const styles = {
  page: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#05030c",
    overflow: "hidden"
  },
  header: {
    minHeight: 54,
    padding: "8px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexShrink: 0,
    background: "#05050d",
    borderBottom: "1px solid rgba(196,104,255,.28)",
    fontFamily: "'JetBrains Mono', monospace"
  },
  brand: {
    color: "#e2b2ff",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 3
  },
  subtitle: {
    color: "#81758d",
    fontSize: 9,
    letterSpacing: 2,
    marginTop: 3
  },
  selection: {
    color: "#8dffbd",
    fontSize: 10,
    letterSpacing: 1.5
  },
  backButton: {
    padding: "8px 14px",
    color: "#e5c4ff",
    background: "rgba(150,62,210,.12)",
    border: "1px solid rgba(201,132,255,.4)",
    fontFamily: "inherit",
    fontSize: 10,
    letterSpacing: 1.5,
    cursor: "pointer"
  },
  iframe: {
    width: "100%",
    flex: 1,
    border: 0,
    background: "#070311"
  }
};
